"use client";

interface IconBenefitCard {
	title?: string;
	description?: string;
    icon: React.ReactNode;
    bgColor: string;
    textColor?: string;
    onlyIcon?: boolean;
}

interface IconBenefitsSectionProps {
    cards: IconBenefitCard[];
}

export function IconBenefitsSection({
    cards,
}: IconBenefitsSectionProps) {
	return (
		<div className="my-2 lg:my-8 flex w-full flex-col">
			<div className="sm:mt-6 md:mt-8 w-full">
				<div className="container mx-auto px-6 lg:px-8">
					<div className="grid grid-cols-1 gap-5 lg:gap-8 xl:gap-12 sm:grid-cols-1 md:grid-cols-3">
						{cards.map((card, index) => (
							<div key={index} className={`${card.bgColor} rounded-3xl ${card.onlyIcon ? 'p-0 overflow-hidden' : 'px-12 sm:px-4 py-8 md:py-12 lg:p-12'} ${card.textColor || 'text-white'} relative flex flex-col h-full`}>
								<div className="relative z-10 mb-3 xl:mb-6">
									{card.icon}
								</div>
								
								{(card.title || card.description) && !card.onlyIcon && (
									<div className="flex-1 flex flex-col">
										{card.title && <h4 className={`relative z-10 ${card.textColor || 'text-white'} mb-4`}>{card.title}</h4>}
											{card.description && (
											<p className={`${card.textColor || 'text-white'} relative z-10 mt-auto`}>
												{card.description}
											</p>
										)}
									</div>
								)}
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
